import "../index.css";
import "../i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@/lib/theme";
import { AdminAppRoot } from "./app";

/** The admin app's UI (ADR 0016), built from admin-app.html by vite.admin-app.config.ts. */
createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <ThemeProvider>
      <AdminAppRoot />
    </ThemeProvider>
  </StrictMode>,
);
